function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStatusReceived = function SvgStatusReceived(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8.3 14.6v.8H3a.7.7 0 0 1-.7-.9.646.646 0 0 1 .2-.5 1.463 1.463 0 0 1 .5-.3h5.4c0 .3-.1.5-.1.9zm1.6-4.1a5.547 5.547 0 0 0-.6.8 5.9 5.9 0 0 0-.4.8H3a.7.7 0 0 1-.7-.9.646.646 0 0 1 .2-.5.781.781 0 0 1 .5-.2zm1.7-2.2a.676.676 0 0 1-.3.6.781.781 0 0 1-.5.2H3a1.463 1.463 0 0 1-.5-.3 1.191 1.191 0 0 1-.2-.6.646.646 0 0 1 .2-.5.646.646 0 0 1 .5-.3h7.8a.544.544 0 0 1 .5.3.6.6 0 0 1 .3.6z",
    style: {
      fill: "#40ce66"
    },
    transform: "translate(.76 .39)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 3.1h-1.3V3a1.453 1.453 0 0 0-1.4-1.5h-1A3.09 3.09 0 0 0 7.1 0a2.486 2.486 0 0 0-1.9.9 1.1 1.1 0 0 0-.3.6h-1A1.612 1.612 0 0 0 2.4 3v.1H1.1a1.028 1.028 0 0 0-1.1 1v13.7a1.11 1.11 0 0 0 1.1 1.1h8.6a5.547 5.547 0 0 1-.6-.8 1.329 1.329 0 0 1-.3-.7H1.7V4.7h.7A1.288 1.288 0 0 0 3.8 6h6.4a1.408 1.408 0 0 0 1.4-1.3h.7v3.9a4.649 4.649 0 0 1 .9-.3c.2-.1.5-.1.7-.2v-4a1.087 1.087 0 0 0-.1-.5c0-.1-.1-.2-.2-.4a1.759 1.759 0 0 0-.6-.1zm-2.9.1v1.2H4V3.2h1.4a.882.882 0 0 0 .9-.8.789.789 0 0 1 .8-.8.761.761 0 0 1 .8.7.876.876 0 0 0 .9.8z",
    style: {
      fill: "#40ce66"
    },
    transform: "translate(.76 .39)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.7-.1A5.784 5.784 0 0 0-.1 5.6a5.72 5.72 0 0 0 5.8 5.7 5.7 5.7 0 1 0 0-11.4zm0 9.7a4 4 0 1 1 4-4 4.012 4.012 0 0 1-4 4z",
    "data-name": "Path 11817",
    style: {
      fill: "#40ce66"
    },
    transform: "translate(10.144 9.537)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 4.4a.842.842 0 0 1-.4.7c-.4.3-1.2 1.3-2.3 2.5-.1 0-.1.1-.3.1a1.007 1.007 0 0 1-.3.1.765.765 0 0 1-.5-.2L3.2 6.1a.746.746 0 0 1 0-.9.775.775 0 0 1 1-.2 5.241 5.241 0 0 1 1.1 1c.7-.8 1.3-1.4 1.8-1.9a.932.932 0 0 1 .7-.4.646.646 0 0 1 .5.2.588.588 0 0 1 .2.5z",
    "data-name": "Path 11818",
    style: {
      fill: "#40ce66"
    },
    transform: "translate(10.144 9.537)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22v22H0z",
    style: {
      fill: "none"
    }
  }));
};
export default SvgStatusReceived;